import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']
})
export class AuthenticationComponent implements OnInit, OnDestroy {

    bodyClasses = 'skin-green layout-top-nav';
    body: HTMLBodyElement = document.getElementsByTagName('body')[0];

    constructor() { }

    ngOnInit() {
        // add the the body classes
        this.body.classList.add('skin-green');
        this.body.classList.add('layout-top-nav');
    }

    ngOnDestroy() {
        // remove the the body classes
        this.body.classList.remove('skin-green');
        this.body.classList.remove('layout-top-nav');
    }

}
